import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Speaker, SpeakerOutlined } from '@mui/icons-material';
import { SONOS_BLUE, sonosIconTapSx } from './sonosUiStyles';

interface SonosGroupSpeakerIconProps {
  hasSpeaker: boolean;
  destCount: number;
  onClick: (e: React.SyntheticEvent) => void;
}

/** Icono de parlante con contador de grupo (mismo aspecto que reproductor compacto/expandido). */
const SonosGroupSpeakerIcon: React.FC<SonosGroupSpeakerIconProps> = ({
  hasSpeaker,
  destCount,
  onClick,
}) => (
  <IconButton
    onClick={onClick}
    disableRipple
    sx={{
      color: '#fff',
      p: 0.45,
      position: 'relative',
      ...sonosIconTapSx,
    }}
  >
    {hasSpeaker ? (
      <Speaker sx={{ fontSize: 22 }} />
    ) : (
      <SpeakerOutlined sx={{ fontSize: 24, color: SONOS_BLUE }} />
    )}
    {hasSpeaker && destCount > 0 && (
      <Box sx={{
        position: 'absolute',
        top: -2,
        right: -4,
        width: 14,
        height: 14,
        borderRadius: '50%',
        backgroundColor: SONOS_BLUE,
        color: '#fff',
        fontSize: 9,
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {destCount}
      </Box>
    )}
  </IconButton>
);

export default SonosGroupSpeakerIcon;
